window.interAtiv = false
window.inativoA = 0 // A quanto tempo o usuario está inativo em minutos
async function contador (e = false) {
  if (!e) {
    window.inativoA = localStorage.getItem('inativoA') | 0
  } else {
    window.inativoA = 0
  }
  localStorage.setItem('inativoA', window.inativoA)
  if (window.interAtiv) clearInterval(window.interAtiv)
  window.interAtiv = setInterval(function () {
    window.inativoA = window.inativoA + 1
    localStorage.setItem('inativoA', window.inativoA)
  }, 1000)
}
contador()

window.addEventListener('click', contador)
window.addEventListener('keyup', contador)



// WEBPACK FOOTER //
// ./src/service/atividade.js